import { facebookLoginAppId, environment } from './config'
import { language } from './locale'
import { isSSR } from './isSSR'

export const DecodeHTML = html => {
  if (isSSR) return html
  else {
    var txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }
}

export const Capitalize = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const DashesToSpaces = string => {
  return string.split('-').join(' ')
}

export const truncateString = (string, maxLength = 130) => {
  if (string.length < maxLength) return string

  const truncated = string
    .substr(0, maxLength)
    .trim()
    .replace(/\W+$/, '')

  return truncated + '…'
}

export const GetCleanedPaths = (keepPages, url) => {
  let paths = (url && url.split('/')) || document.location.pathname.split('/')
  let i = paths.length

  // Remove unwanted parts of the paths
  while (i--) {
    // Empty strings
    if (paths[i] === '') {
      paths.splice(i, 1)
    } else {
      // Language slugs
      for (var lang in language) {
        if (Object.prototype.hasOwnProperty.call(language, lang)) {
          if (paths[i] === language[lang]) {
            paths.splice(i, 1)
          }
        }
      }

      // Pagination
      if (!keepPages) {
        if (paths[i] === 'page') {
          // First remove `page`
          paths.splice(i, 1)
          // Then the page number
          paths.splice(i, 1)
        }
      }
    }
  }

  return paths
}

export const GetLastPath = () => {
  const cleanedPaths = GetCleanedPaths()
  return cleanedPaths[cleanedPaths.length - 1]
}

export const GetPaginationPage = () => {
  return parseInt(
    document.location.href
      .split('/page/')
      .pop()
      .slice(0, 2)
      .replace('/', ''),
    10
  )
}

export const trailingSlash = path => {
  // Add trailing slash, if needed and no params are present
  if (
    path.indexOf('?') === -1 &&
    typeof path.split('').pop() !== 'undefined' &&
    path.split('').pop() !== '/'
  ) {
    return '/'
  } else {
    return ''
  }
}

export const CreateLink = (path, currentLanguage = 'en') => {
  let link

  if (currentLanguage !== 'en') {
    link = `/${currentLanguage}/${path}` + trailingSlash(path)
  } else {
    link = `/${path}` + trailingSlash(path)
  }

  return link.replace('//', '/')
}

export const insertFBScript = () => {
  if (!document.getElementById('facebook-script')) {
    let script = document.createElement('script')
    script.setAttribute('id', 'facebook-script')
    script.textContent = `(function(d, s, id) {
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s); js.id = id;
              js.src = "https://connect.facebook.net/en_US/sdk.js";
              fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            window.fbAsyncInit = function() {
              FB.init({
                appId: ${facebookLoginAppId},
                cookie: true,
                xfbml: true,
                version: 'v3.2'
              });
          }`
    document.getElementsByTagName('body')[0].appendChild(script)
  }
}

export const insertAdyenScript = () => {
  return new Promise((resolve, reject) => {
    if (window.AdyenCheckout) {
      resolve()
    } else if (!document.querySelector('script[src*="adyen"]')) {
      const env = environment === 'production' ? 'live' : 'test'
      let script = document.createElement('script')
      script.setAttribute(
        'src',
        `https://checkoutshopper-${env}.adyen.com/checkoutshopper/sdk/3.4.0/adyen.js`
      )
      document.getElementsByTagName('body')[0].appendChild(script)

      let link = document.createElement('link')
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute(
        'href',
        `https://checkoutshopper-${env}.adyen.com/checkoutshopper/sdk/3.4.0/adyen.css`
      )
      document.getElementsByTagName('body')[0].appendChild(link)
    }

    let i = 0
    const interval = setInterval(() => {
      if (
        window.AdyenCheckout &&
        document.querySelector('script[src*="adyen"]')
      ) {
        clearInterval(interval)
        resolve()
      }

      if (i > 50) {
        // 5 seconds
        clearInterval(interval)
        reject()
      }

      i++
    }, 100)
  })
}

export const shuffleArray = array => {
  let m = array.length,
    t,
    i

  // While there remain elements to shuffle…
  while (m) {
    // Pick a remaining element…
    i = Math.floor(Math.random() * m--)

    // And swap it with the current element.
    t = array[m]
    array[m] = array[i]
    array[i] = t
  }

  return array
}

export const isFeatured = article =>
  article.acf &&
  article.acf.featured_article &&
  article.acf.featured_article[0] === 'true'

export const getSortIndex = article => {
  if (!article.acf || !article.acf.sort_index) return null
  return parseInt(article.acf.sort_index)
}

export const sortByIndex = (a, b) => {
  const aIndex = getSortIndex(a)
  const bIndex = getSortIndex(b)

  if (aIndex === null && bIndex === null) {
    return Date.parse(b.published_gmt) - Date.parse(a.published_gmt)
  }

  if (aIndex === null) return 1
  if (bIndex === null) return -1

  return aIndex - bIndex
}

export const wait = milliseconds =>
  new Promise(resolve => setTimeout(() => resolve(), milliseconds))

export const getDisplayName = Component =>
  Component.displayName || Component.name || 'Component'

export const isPast = timestamp => Date.now() >= timestamp

export const format = (string, values) =>
  string.replace(/{([^}]+)}/g, (str, key) =>
    typeof values[key] === 'undefined' ? str : values[key]
  )

export const priceDiff = products => {
  const prices = products.map(({ pricePerMonth }) => pricePerMonth)
  const lowPrice = Math.min(...prices)
  const highPrice = Math.max(...prices)
  return Math.floor(100 - (lowPrice / highPrice) * 100)
}

export const obfuscateEmail = email => {
  const [name, domain] = email.split('@')
  return `${name
    .substr(0, name.length > 7 ? 4 : 1)
    .padEnd(name.length, '*')}@${domain}`
}

export const calculateBMI = (weight, height) => {
  return Math.round((weight / height ** 2) * 100000) / 10
}

export const isStringNumber = s => {
  return +s + '' === s
}

// Extracted as method for test mocking purposes
export const getTimestamp = () => new Date().getTime()

// Extracted as method for test mocking purposes
export const getDate = () => new Date()

export const parseJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export function titleCase(str) {
  str = str.toLowerCase().split(' ')

  let final = []

  for (let word of str) {
    final.push(word.charAt(0).toUpperCase() + word.slice(1))
  }

  return final.join(' ')
}

export function contentfulSrcSet(url) {
  return [300, 600, 900, 1200, 1500, 1800, 2100, 2400]
    .map(size => `${url}?w=${size} ${size}w`)
    .join(',')
}
